export const NUMBER_MASK = /^[0-9]*$/;

export const NEGATIVE_NUMBER_MASK = /^-?[0-9]*$/;

export const PLACEHOLDER_UNDERSCORE = '_';
